import React, { FC } from 'react';
import './VerticalStepper.scss';

export type ISubStep = {
  title: string;
  date: string;
  description: string;
  headerActions?: React.ReactNode[];
};

export type IStep = {
  title: string;
  titleColor: string;
  icon: React.ReactNode;
  subSteps?: ISubStep[];
  isOpaque?: boolean;
};

interface VerticalStepperProps {
  steps: IStep[];
}

/**
 * Stepper vertical anidado: pasos agrupados y subpasos con líneas verticales.
 * Cada subpaso puede incluir `headerActions` (p. ej. botones) a la derecha del título/fecha/descripción.
 */
const VerticalStepper: FC<VerticalStepperProps> = ({ steps }) => {
  return (
    <div className="verticalStepper">
      {steps.map(({ subSteps, ...step }, stepIdx) => {
        const hasSubSteps = subSteps && subSteps.length > 0;
        const opacityClass = step.isOpaque ? 'subStepOpaque' : '';
        const emptySubStepsContainerClass = !hasSubSteps ? 'emptySubStepsContainer' : '';

        return (
          <div key={stepIdx} className={`stepContainer ${opacityClass}`}>
            <div className="stepLine"></div>
            <div className="stepHeader">
              <div className="stepIconContainer">{step.icon}</div>
              <p className={`stepTitle ${step.titleColor}`}>{step.title}</p>
            </div>

            <div className={`subStepsContainer ${emptySubStepsContainerClass}`}>
              {hasSubSteps &&
                subSteps.map((subStep, subStepIdx) => (
                  <div key={subStepIdx} className="subStepContent">
                    <div className="subStepLine"></div>
                    <div className="subStepHeader">
                      <div className="subStepCircle"></div>
                      <div className="subStepHeaderContent">
                        <div className="subStepHeaderMain">
                          <span className="subStepTitle">{subStep.title}</span>
                          <span className="subStepDate">{subStep.date}</span>
                          <p className="subStepDescription">{subStep.description}</p>
                        </div>
                        {!!subStep?.headerActions?.length && (
                          <div className="subStepHeaderActions">
                            {subStep.headerActions.map((actionNode, actionIdx) => (
                              <span className="subStepHeaderActionSlot" key={actionIdx}>
                                {actionNode}
                              </span>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              {!hasSubSteps && <div className="emptySubStepSpacer"></div>}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default VerticalStepper;
